<script lang="ts" setup>
import { FireOutbreak } from '@/@core/fire-risk-dashboard/domain/entities/FireOutbreak'
import DangerRiskIcon from './DangerRiskIcon.vue'
import NormalRiskIcon from './NormalRiskIcon.vue'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import FireOubreakCardMenu from './FireOubreakCardMenu.vue'
import { ShareFireOutbreakAlertEnum } from '../enums/ShareFireOutbreakAlert.enum'
import FireOutbreakCardReactionMenu from './FireOutbreakCardReactionMenu.vue'

const { alert } = defineProps<{
	alert: FireOutbreak
}>()

const emit = defineEmits<{
	(event: 'reaction', value: FireOutbreakReactionEnum): void
	(event: 'shareTo', value: ShareFireOutbreakAlertEnum): void
	(event: 'focus'): void
}>()

// Clique no card marca o alerta como visto e pede o zoom no foco. Cliques nos
// menus (compartilhar/avaliar) só marcam como visto: não devem mover o mapa.
function handleClick(event: MouseEvent) {
	alert.haveSeenAlert()
	if ((event.target as HTMLElement).closest('[data-card-menu]')) return
	emit('focus')
}
</script>

<template>
	<div
		@click="handleClick"
		class="border !border-black-neutral p-3 rounded-[4px] flex cursor-pointer"
		:class="{ '!border-red-danger': !alert.seen }"
	>
		<div class="flex flex-col gap-2">
			<label
				class="text-default-bold !text-blue-base"
				:class="{ '!text-red-danger': !alert.seen }"
				>{{ alert.farm }}</label
			>
			<p class="flex gap-1 !m-0 items-center">
				<span class="text-xs-bold text-black-neutral">{{ $t('fireRiskDashboardTimestamp') }}</span>
				<span class="text-xs text-gray-dark">{{ alert.statedAtLabel }}</span>
			</p>
			<p class="flex gap-1 !m-0 items-center">
				<span class="text-xs-bold text-black-neutral">{{ $t('fireRiskDashboardId') }}</span>
				<span class="text-xs text-gray-dark">{{ alert.codeLabel }}</span>
			</p>
			<!-- Coordenadas na mesma linha: a lista do mapa tem altura fixa e cabem 4 cards de 3 linhas. -->
			<p class="flex flex-wrap gap-x-3 gap-y-1 !m-0 items-center">
				<span class="flex gap-1 items-center">
					<span class="text-xs-bold text-black-neutral">{{ $t('fireRiskDashboardCoordX') }}</span>
					<span class="text-xs text-gray-dark">{{ alert.longitude }}</span>
				</span>
				<span class="flex gap-1 items-center">
					<span class="text-xs-bold text-black-neutral">{{ $t('fireRiskDashboardCoordY') }}</span>
					<span class="text-xs text-gray-dark">{{ alert.latitude }}</span>
				</span>
			</p>
		</div>
		<div class="flex flex-col justify-center items-center">
			<label
				class="text-l-bold text-blue-base w-fit"
				:class="{ 'text-red-danger': !alert.seen }"
				>{{ alert.detectionConfidenceLabel }}</label
			>
			<DangerRiskIcon v-if="!alert.seen" />
			<NormalRiskIcon v-else />
		</div>
		<div
			data-card-menu
			class="flex flex-col justify-between items-end"
		>
			<fire-oubreak-card-menu
				:seen="alert.seen"
				@change="emit('shareTo', $event)"
			/>
			<fire-outbreak-card-reaction-menu
				@reaction="emit('reaction', $event)"
				:alert="alert"
			/>
		</div>
	</div>
</template>
